import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HomeService } from 'src/app/_services/home.service';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {    
    homeBlocks: any;
    homeHash: any;
    homeAddress: any;
    noBlocks = true;
    btcTickets: any;
    btcTicketsAll: any;
    btcTicketsDraw: any;
    faSearch = faSearch;
    submitted = false;
    isHome = true;
    isSearch = false;
    isHashSearch = false;
    isAddress = false;
    isAllTransaction = false;
    isDonation = false;
    recherche = '';
    interval: any;
    btcPoints: string = '';
    width = 100;
    height = 50;
    title = '';
    searchForm: FormGroup = new FormGroup({
        rechercher: new FormControl('')
    });

    constructor(private fb: FormBuilder, private homeService: HomeService) {
        homeService.SharingData.subscribe((res: any) => {
            if (res === true) {
                this.isHome = false;
                this.isSearch = false;
                this.isHashSearch = false;
                this.isAddress = false;
                this.isAllTransaction = false;
            }
            this.isDonation = res
        })
    }

    ngOnInit() {
        this.searchForm = this.fb.group({
            rechercher: ['', Validators.required]
        });
        if (this.isSearch == false) {
            this.refreshDatasFilparty();
            this.interval = setInterval(() => {
                this.refreshDatasFilparty();
            }, 3000)
        }

        this.refreshingBTC();
        setInterval(() => {
            this.refreshingBTC();
        }, 300000)
    }

    get f(): { [key: string]: AbstractControl } {
        return this.searchForm.controls;
    }

    getAllBlocks(): any {
        return this.homeBlocks;
    }

    refreshDatasFilparty(): void {
        this.homeService.getBlocks().then(data => {
            this.homeBlocks = data.blocks;
        });
        this.homeService.getFilPartyStat().then(data => {
            this.btcTickets = data
        })
    }

    refreshingBTC(): void {
        this.homeService.getBTCTicketsData(0, 20).then(data => {
            this.btcTicketsAll = data.Data;
            // this.btcTickets = this.btcTicketsAll.filter((x: any) => {
            //     if (x.CoinInfo.Name == 'BTC' || x.CoinInfo.Name == 'ETH') {
            //         return x
            //     }
            // })
            // this.btcTickets = this.btcTickets.map((x: any) => {
            //     return { last_trade_price: x.DISPLAY.USD.PRICE, evol: x.DISPLAY.USD.CHANGEPCTHOUR, symbol: x.CoinInfo.Name }
            // });
            // this.btcTickets.sort((a: any, b: any) => a.symbol < b.symbol ? 1 : -1)
            this.btcTicketsAll = this.btcTicketsAll.filter((x: any) => x.hasOwnProperty('DISPLAY'));
            // this.btcTicketsDraw = [...this.btcTicketsAll];
            // this.btcTicketsDraw.sort((a: any, b: any) => a.RAW.USD.LASTUPDATE > b.RAW.USD.LASTUPDATE ? 1 : -1);
            // const t = this.btcTicketsAll.find((t: any) => t.RAW.USD.LASTUPDATE === 1651310738);
            // let date = new Date(this.btcTicketsDraw[0].RAW.USD.LASTUPDATE*1000);
            // let last = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000));
            // this.homeService.getGrapheDatas('BTC,ETH', Math.floor(last.getTime()/1000), Math.floor(date.getTime()/1000)).then((datas) => {
                
            //     this.width = this.textarea.nativeElement.offsetWidth;
            //     this.height = this.textarea.nativeElement.offsetHeight;
   
            //     console.log(datas);
            //     console.log('With ', this.textarea.nativeElement.offsetWidth);
            //     let elt = '';
            //     const btc = datas.pairs['USD-BTC'].map((d: any, index: number) => {
            //         if (index === 0) {
            //             elt = 'M 0 '+(this.height/d.value).toString()+' '
            //         } else {

            //         }
            //         return ((index*100)/this.width).toString()+','+(d.value/this.height).toString();
            //     })
            //     this.btcPoints = btc.join(' ');
            // })
        }).catch(err => console.log(err))
    }

    onSubmit() {
        this.submitted = true;
        if (this.searchForm.invalid) {
            return;
        }
        
        this.isHome = false;
        this.recherche = (this.searchForm.value.rechercher).trim();
        clearInterval(this.interval);
        if (this.recherche.startsWith('0x') && this.recherche.length > 54) {
            this.isSearch = false;
            this.isAddress = false;
            this.isHashSearch = true;
            this.homeService.checkBlocks('transaction_new', this.recherche).then((block) => {
                this.homeHash = [block.transaction];
                this.title = 'Hash';
            })
        } else {
            if ((/^-?\d+$/.test(this.recherche))){
                this.isHashSearch = false;
                this.isAddress = false;
                this.isSearch = true;
                this.homeService.checkBlocks('block', this.recherche).then((block) => {
                    this.homeBlocks = [block.blocks];
                }).catch((error) => {
                    // console.log(error)
                    this.isHome = true;
                    this.isSearch = false;
                    this.isHashSearch = false;
                    this.isAddress = false;
                })
            } else {
                this.isSearch = false;
                this.isHashSearch = false;
                this.isAddress = true;
                this.homeService.checkBlocks('address', this.recherche).then((block) => {
                    this.homeAddress = block;
                }).catch((error) => {
                    // console.log(error)
                    this.isHome = true;
                    this.isSearch = false;
                    this.isHashSearch = false;
                    this.isAddress = false;
                })
            }
        }
        this.searchForm.reset()
    }

    homepage() {
        this.refreshDatasFilparty();
        this.isHome = true;
        this.isSearch = false;
        this.isHashSearch = false;
        this.isAddress = false;
    }

    openBlock(block: any, len: any) {
        this.isHome = false;
        this.isSearch = false;
        this.isHashSearch = true;
        this.homeService.getTransactionsData(block, len).then((block) => {
            this.homeHash = block.transactions;
            this.title = 'Block number';
        })
    }

    viewTransaction(e: any) {
        e.stopPropagation();
        clearInterval(this.interval);
        this.isHome = false;
        this.isSearch = false;
        this.isHashSearch = false;
        this.isAddress = false;
        this.isAllTransaction = true;
    }
}
